/**
 * To use this module, add the following data attribute to any element in your html:
 * data-js-module="store-search"
 */
export default class StoreSearch {
    el;

    headerGeoCoderData = {
        features: this.storeList,
        type: 'FeatureCollection',
    };

    constructor() {
        this.init();
    }

    async init() {
        this.el = $('[data-js-module="store-search"]');

        $(() => {
            const lrrMap = new LRR.Map(LigneRosetConfig.MapboxToken);

            lrrMap.gecoderConfig = {
                ...lrrMap.gecoderConfig,
                types: 'postcode,place',
                placeholder: __('form.city_or_postal_code'),
                countries: LigneRosetConfig.Country + (LigneRosetConfig.StoreLocatorGeocoderAdditionalCountries ? `,${LigneRosetConfig.StoreLocatorGeocoderAdditionalCountries}` : ''),
                limit: 3,
            };

            this.el.each(function () {
                const geocoder = lrrMap.initGeocoder(LigneRosetConfig.Locale);
                geocoder.on('result', (event) => {
                    const { result } = event;
                    let href;
                    let text = '';
                    if (result?.place_type.includes('postcode')) {
                        result.context.every((c) => {
                            if (c.id.startsWith('place')) {
                                text = c.text;
                                return false;
                            }
                            return true;
                        });
                    } else {
                        text = result.text;
                    }
                    // href = LigneRosetConfig.StoreLocatorCityUrl.replace('city', text.toLowerCase());
                    href = LigneRosetConfig.StoreLocatorCountryUrl;

                    let hrefParams = '';

                    let regionShortCode = lrrMap.extractRegionShortCode(result.context);
                    if (regionShortCode) {
                        hrefParams += `region=${regionShortCode}&`;
                    }

                    if (result.geometry?.coordinates) {
                        hrefParams += `lat=${result.geometry.coordinates[1]}&lng=${result.geometry.coordinates[0]}&`;
                    }

                    if (hrefParams) {
                        href += `?${hrefParams}`;
                    }

                    window.location.href = href;
                });

                $(this).append(geocoder.onAdd('#header-map'));
                if ($(this).hasClass('mobile')) {
                    $(this).find('input').focus(() => {
                        $('html, body').animate({ scrollTop: ($(this).offset().top - 10) }, 1);
                        return false;
                    });
                }
            });
        });
    }
}
